<ng-container *transloco="let t;">
<div>
    <!-- Header -->
    <div class="d-flex justify-content-between align-items-center content-sidebar-header py-75 px-1 mt-50 mb-1">
        <div class="linked-organization-inner">
            <div class="d-flex justify-content-start align-items-center">
                <div class="user-page-info">
                    <h5 class="mb-0">
                        {{t("Pdf block settings PDF fields text (Template/Document - section) - PDF fields")}}
                    </h5>
                </div>
            </div>
        </div>
        <div class="cursor-pointer closeMenu" (click)="clsoe()">
            <i data-feather="x" [size]="16" class="ms-0"></i>
        </div>
    </div>
    <div class="pdf-upload-setting-scroll editorTabScroll px-75">
        <div class="content-listItem-containet mt-0">
            <div cdkDropList class="field-block-container">
            <div cdkDrag [attr.field]="field.field_block" class="content-listItem" field-type="default" [attr.type]="field.type" *ngFor="let field of fieldsBlock" (cdkDragStarted)="onDragStart($event)" (cdkDragEnded)="onDragEnd($event)" [cdkDragData]="field">
    
               <!-- Fields Drag Preview -->
               <div *ngIf="field.field_block === 'text-field'">
                 <div class="drag-fields" *cdkDragPreview><span class="placeholder-field-label">{{t("Content new field (Template/Document - section) - Field name - New field")}}</span></div>
               </div>
    
               <div *ngIf="field.field_block === 'checkbox-field'">
                <div class="drag-fields checkbox-field" *cdkDragPreview><div class="drag-fields-inner-container checkbox-field-inner-container"><div class="checkbox-field-box"></div><span class="field-label">{{t("Content new field (Template/Document - section) - Field name - New field")}}</span></div></div>
               </div>
    
               <div *ngIf="field.field_block === 'datepicker-field'">
                <div class="drag-fields datepicker-field" *cdkDragPreview><span class="placeholder-field-label">{{t("Content new field (Template/Document - section) - Field name - New field")}}</span></div>
               </div>
    
               <div *ngIf="field.field_block === 'signature-field'">
                <div class="drag-fields signature-field" *cdkDragPreview><span class="placeholder-field-label">{{t("Content signature field (Template/Document - section) - Signature Field")}}</span></div>
               </div>
               
               <div *ngIf="field.field_block === 'droplist-field'">
                <div class="drag-fields droplist-field" *cdkDragPreview><span class="placeholder-field-label">{{t("Content droplist select option (Template/Document - section) - Select option")}}</span></div>
               </div>
    
               <div *ngIf="field.field_block === 'multichoice-field'">
                <div class="drag-fields multichoice-field multiChoice-radio content-draggable-field" *cdkDragPreview><span class="placeholder-field-label placeholder-multiChoicefield-label">{{t("Content droplist select option (Template/Document - section) - Select option")}}</span><div class="multiChoice-item-container"><div class="multiChoice-item"><div class="multiChoice-box"><div class="multiChoice-inner-circle"></div></div><label class="multiChoice-label-text">{{t("Content drop list option menu - (Template/Document - section) - Option")}} 1</label></div><div class="multiChoice-item"><div class="multiChoice-box"><div class="multiChoice-inner-circle"></div></div><label class="multiChoice-label-text">{{t("Content drop list option menu - (Template/Document - section) - Option")}} 2</label></div></div></div>
               </div>
               <!-- / Fields Drag Preview -->
    
               <div class="content-item-box">
                  <div class="content-item-box-dragIcon">
                     <svg viewBox="0 0 24 24" role="presentation" width="20" height="20">
                        <path d="M9 7h2v2H9V7zm0 4h2v2H9v-2zm0 4h2v2H9v-2zm4-8h2v2h-2V7zm0 4h2v2h-2v-2zm0 4h2v2h-2v-2z" fill-rule="evenodd"></path>
                     </svg>
                  </div>
                  <div class="content-item-box-text">
                     <span>{{ field.name }}</span>
                     
                     <div class="content-item-svgicon">
                        <svg viewBox="0 0 24 24" role="presentation" class="text-field-svg" *ngIf="field.field_block === 'text-field'">
                           <path d="M19 21V3h2v18h-2zM9.19 6.106h1.62L16 17.959h-2l-1.132-2.735H7.132L6 17.959H4L9.19 6.106zM10 8.84L8.146 13.4h3.708L10 8.841z" fill-rule="evenodd"></path>
                        </svg>
    
                        <svg viewBox="0 0 24 24" role="presentation" class="check-box-svg" *ngIf="field.field_block === 'checkbox-field'">
                           <path d="M3 21V3h18v18H3zm2-2h14V5H5v14zM17.722 8.691l-7.42 7.753-4.023-4.18 1.442-1.386 2.577 2.677 5.98-6.247 1.444 1.383z" fill-rule="evenodd"></path>
                        </svg>
    
                        <svg viewBox="0 0 24 24" role="presentation" class="droplist-svg" *ngIf="field.field_block === 'droplist-field'">
                           <defs>
                              <path id="FieldDropdown_svg__a" d="M18 10l-4 5.28L10 10h8zM2 20V4h20v16H2zm2-1.999h16V6H4v12.001z"></path>
                           </defs>
                           <use xlink:href="#FieldDropdown_svg__a" fill-rule="evenodd"></use>
                        </svg>
    
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" class="list-svg" *ngIf="field.field_block === 'multichoice-field'">
                           <g data-name="Layer 2"><rect width="10" height="10" x="2" y="18" rx="2"/><path d="M7 13a2.973 2.973 0 0 1-2.12-.88l-1-1A3 3 0 0 1 6 6a3.084 3.084 0 0 1 .68.08L8.76 4H4a2.006 2.006 0 0 0-2 2v6a2.006 2.006 0 0 0 2 2h6a2.006 2.006 0 0 0 2-2V9.24l-2.88 2.88A2.973 2.973 0 0 1 7 13zm8-5h14a1 1 0 0 0 0-2H15a1 1 0 0 0 0 2zm0 4h9a1 1 0 0 0 0-2h-9a1 1 0 0 0 0 2zm14 8H15a1 1 0 0 0 0 2h14a1 1 0 0 0 0-2zm-5 4h-9a1 1 0 0 0 0 2h9a1 1 0 0 0 0-2z"/><path d="M10.293 5.293 7 8.586l-.293-.293a1 1 0 0 0-1.414 1.414l1 1a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414Z"/></g>
                       </svg>
    
                       <svg viewBox="0 0 24 24" role="presentation" class="date-picker-svg" *ngIf="field.field_block === 'datepicker-field'">
                           <path d="M15 3h2v2h4v16H3V5h4V3h2v2h6V3zM5 19h14V9H5v10zm2-6v-2h2v2H7zm0 4v-2h2v2H7zm4-4v-2h2v2h-2zm0 4v-2h2v2h-2zm4-4v-2h2v2h-2zm0 4v-2h2v2h-2z" fill-rule="evenodd"></path>
                        </svg>
    
                        <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-signature signature-svg" width="44" height="44" viewBox="0 0 24 24" stroke-width="1.5" stroke="#2c3e50" fill="none" stroke-linecap="round" stroke-linejoin="round" *ngIf="field.field_block === 'signature-field'">
                           <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                           <path d="M3 17c3.333 -3.333 5 -6 5 -8c0 -3 -1 -3 -2 -3s-2.032 1.085 -2 3c.034 2.048 1.658 4.877 2.5 6c1.5 2 2.5 2.5 3.5 1l2 -3c.333 2.667 1.333 4 3 4c.53 0 2.639 -2 3 -2c.517 0 1.517 .667 3 2" />
                         </svg>
                     </div>
                  </div>
               </div>
            </div>
         
         </div>
        </div>
        
        <div class="form-group px-25 mt-1 conditional-dropdown">
            <app-conditional-fields
                [uuid]="data['uuid']"
                [block]="pdfBlock"
            ></app-conditional-fields>
        </div>
        
        <div class="form-group px-25 mt-1 hidden">
            <label for="customRange3" class="form-label">Zoom</label>
            <input type="range" class="form-range" min="0.4" max="1" step="0.1" id="zoom" [(ngModel)]="rangeValue" (input)="onRangeChange($event)">
        </div>
    </div>
</div>
</ng-container>
